import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider } from '@/contexts/AuthContext';
import { Toaster } from '@/components/ui/sonner';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import Home from '@/pages/Home';
import Legislature from '@/pages/Legislature';
import Representatives from '@/pages/Representatives';
import EngagementTools from '@/pages/EngagementTools';
import EngagementLadder from '@/pages/EngagementLadder';
import Articles from '@/pages/Articles';
import Templates from '@/pages/Templates';
import FAQs from '@/pages/FAQs';
import Search from '@/pages/Search';
import Admin from '@/pages/Admin';
import AdminManagement from '@/pages/AdminManagement';
import AdminUsers from '@/pages/AdminUsers';
import ForgotPassword from '@/pages/ForgotPassword';
import ResetPassword from '@/pages/ResetPassword';
import '@/App.css';

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <div className="App min-h-screen flex flex-col">
          <Header />
          <main className="flex-1">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/legislature" element={<Legislature />} />
              <Route path="/representatives" element={<Representatives />} />
              <Route path="/engagement-tools" element={<EngagementTools />} />
              <Route path="/engagement-ladder" element={<EngagementLadder />} />
              <Route path="/articles" element={<Articles />} />
              <Route path="/templates" element={<Templates />} />
              <Route path="/faqs" element={<FAQs />} />
              <Route path="/search" element={<Search />} />
              <Route path="/admin" element={<Admin />} />
              <Route path="/admin/manage" element={<AdminManagement />} />
              <Route path="/admin/users" element={<AdminUsers />} />
              <Route path="/admin/forgot-password" element={<ForgotPassword />} />
              <Route path="/admin/reset-password" element={<ResetPassword />} />
            </Routes>
          </main>
          <Footer />
          <Toaster />
        </div>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
